/**
 * The server's own message for a rejected write, or null.
 *
 * The message-template endpoints answer a blocked write with a sentence written for the admin — why a
 * seeded row cannot be deleted, which variables a scope actually offers — so showing a generic
 * "failed to save" would throw away the only useful part of the response.
 */
export const getServerMessage = (error: unknown): string | null => {
	const data = (error as any)?.response?.data;

	if (typeof data === 'string' && data.trim() !== '') {
		return data;
	}

	if (typeof data?.message === 'string' && data.message.trim() !== '') {
		return data.message;
	}

	if (typeof data?.title === 'string' && data.title.trim() !== '') {
		return data.title;
	}

	return null;
};
